import React from 'react';

// Global Form
// @ts-ignore
import RenderDropdown from 'forms/RenderDropdown';
import { Field } from 'react-final-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { selectApplicationRateOptions } from 'services/equipmentSets/selectors';

export interface OwnProps {
    name: string;
    label?: string;
    validate?: any;
    nullOnUnmount?: boolean;
}

interface ConnectedProps {
    options: ReturnType<typeof selectApplicationRateOptions>;
}

type Props = OwnProps & ConnectedProps;

export class ApplicationRateDropdownComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            name,
            label,
            validate,
            options,
            nullOnUnmount = false
        } = this.props;

        return (
            <Field
                component={RenderDropdown as any}
                subscription={{
                    value: true,
                    touched: true,
                    error: true
                }}
                name={name}
                label={label || 'Water rate'}
                placeholder="Select a water rate"
                fluid
                search
                selection
                clearable
                selectOnBlur={false}
                validate={validate}
                options={options}
                nullOnUnmount={nullOnUnmount}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    options: selectApplicationRateOptions
});

export default connect(mapStateToProps)(ApplicationRateDropdownComponent);
